<template>
  <DataTable
    class="tableHeaderStyle"
    :value="settings"
    stripedRows
    tableStyle="min-width: 50rem"
    ref="dt"
    :exportFilename="exportFileName"
  >
    <!-- <Column sortable field="index" header="#" /> -->
    <Column sortable field="date" header="Date">
      <template #body="log">
        {{ formatDate(log.data.date) }}
      </template>
    </Column>
    <Column field="action" header="Settings" />
    <Column sortable field="actionBy" header="Action By" />

    <template #empty>
      <div class="pt-4 text-center">
        <EmptyList :type="'Settings log'" />
      </div>
    </template>
  </DataTable>

  <Pagination :paginationData="pagination" :handler="handlePagination" />
</template>

<script>
//utils
import { formatNumber, formatDate } from "@/utils/formatter";

//libraries
import Column from "primevue/column";
import DataTable from "primevue/datatable";

//components
import ProductType from "@/components/UI/ProductTypes";
import Pagination from "@/components/UI/Pagination/index.vue";
import EmptyList from "@/components/Empty/index.vue";

export default {
  name: "DepotSettingsLog",
  props: [
    "depotId",
    "settings",
    "exportFileName",
    "pagination",
    "handlePagination",
  ],
  components: {
    Column,
    DataTable,
    Pagination,
    ProductType,
    EmptyList,
  },
  data() {
    return {
      formatDate,
      formatNumber,
    };
  },
  mounted() {},
  methods: {
    exportTable() {
      this.$refs.dt.exportCSV();
    },
  },
};
</script>

<style></style>
